<template>
  <div class="p-5 flex flex-column flex-auto surface-section">
    <div class="px-5 text-left flex-auto">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">

</script>